module.exports = __webpack_public_path__ + "static/media/400001_01.91be22ad.png";